import { type CVEditingSection, type FullCV } from '@cibli/shared';

import { useCVTranslation } from '@/features/cv/hooks/useCVTranslation.ts';

import EditableSection from '../../../components/form/EditableSection';

interface SummaryProps {
  summary: FullCV['summary'];
  accent: string;
  onEdit?: (section: CVEditingSection) => void;
}

export default function Summary({ summary, accent, onEdit }: SummaryProps) {
  const { t } = useCVTranslation();
  const handleEdit = () => onEdit && onEdit('summary');
  const editable = onEdit !== undefined;

  if (!summary && !editable) return null;

  return (
    <EditableSection onEdit={handleEdit} editable={editable} accentColor={accent}>
      <div className="mb-2 p-2 m-2">
        <h2 className="text-[11px] font-black uppercase tracking-widest mb-0.25 text-black">
          {t('CV.summary')}
        </h2>
        <p className="text-[11px] text-black leading-relaxed text-justify">
          {summary || (editable ? t('CV.summaryEmptyPlaceholder') : '')}
        </p>
      </div>
    </EditableSection>
  );
}
